var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "attachment-filter" } },
    [
      _c(
        "f7-list",
        { attrs: { accordion: "", id: "payments-attachment-filter" } },
        [
          _c(
            "f7-list-item",
            {
              staticClass: "listBackground",
              attrs: {
                "accordion-item": "",
                title: "Filter By",
                id: "attachment-filter-item",
              },
            },
            [
              _c(
                "f7-accordion-content",
                [
                  _c(
                    "f7-list",
                    [
                      _vm.payments
                        ? _c(
                            "f7-list-item",
                            { staticClass: "filterTypes" },
                            [
                              _c("f7-label", [_vm._v("Status")]),
                              _vm._v(" "),
                              _c(
                                "f7-button",
                                {
                                  staticClass: "buttonFilter",
                                  on: {
                                    click: function ($event) {
                                      _vm.filterByStatus("Waiting")
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-light fa-timer buttonIcon blueIcon",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "f7-button",
                                {
                                  staticClass: "buttonFilter",
                                  on: {
                                    click: function ($event) {
                                      _vm.filterByStatus("NegotiationRequest")
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-duotone fa-comment buttonIcon orangeIcon",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "f7-button",
                                {
                                  staticClass: "buttonFilter",
                                  on: {
                                    click: function ($event) {
                                      _vm.filterByStatus("NegotiationResponse")
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-duotone fa-comments buttonIcon orangeIcon",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "f7-button",
                                {
                                  staticClass: "buttonFilter",
                                  on: {
                                    click: function ($event) {
                                      _vm.filterByStatus("Validated")
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-light fa-check-double buttonIcon greenIcon",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "f7-button",
                                {
                                  staticClass: "buttonFilter",
                                  on: {
                                    click: function ($event) {
                                      _vm.filterByStatus("Modified")
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-light fa-check-double buttonIcon orangeIcon",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "f7-button",
                                {
                                  staticClass: "buttonFilter",
                                  on: {
                                    click: function ($event) {
                                      _vm.filterByStatus("Revoked")
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-light fa-xmark buttonIcon redIcon",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "f7-button",
                                {
                                  staticClass: "buttonFilter",
                                  on: {
                                    click: function ($event) {
                                      _vm.filterByStatus("TransferReceived")
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-light fa-euro-sign buttonIcon yellowIcon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "f7-list-item",
                        { staticClass: "filterTypes" },
                        [
                          _c("f7-label", [_vm._v("Date Begin")]),
                          _vm._v(" "),
                          _vm.payments
                            ? _c("f7-input", {
                                attrs: { type: "date" },
                                model: {
                                  value: _vm.filterDateBegin,
                                  callback: function ($$v) {
                                    _vm.filterDateBegin = $$v
                                  },
                                  expression: "filterDateBegin",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "f7-list-item",
                        { staticClass: "filterTypes" },
                        [
                          _c("f7-label", [_vm._v("Date End")]),
                          _vm._v(" "),
                          _vm.payments
                            ? _c("f7-input", {
                                attrs: { type: "date" },
                                model: {
                                  value: _vm.filterDateEnd,
                                  callback: function ($$v) {
                                    _vm.filterDateEnd = $$v
                                  },
                                  expression: "filterDateEnd",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.payments
                        ? _c(
                            "f7-list-item",
                            { staticClass: "filterTypes" },
                            [
                              _c("f7-label", [_vm._v("Reference")]),
                              _vm._v(" "),
                              _c("f7-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.filterReference,
                                  callback: function ($$v) {
                                    _vm.filterReference = $$v
                                  },
                                  expression: "filterReference",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.received && _vm.payments
                        ? _c(
                            "f7-list-item",
                            { staticClass: "filterTypes" },
                            [
                              _c("f7-label", [_vm._v("Creditor Name")]),
                              _vm._v(" "),
                              _c("f7-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.filterName,
                                  callback: function ($$v) {
                                    _vm.filterName = $$v
                                  },
                                  expression: "filterName",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.received && _vm.payments
                        ? _c(
                            "f7-list-item",
                            { staticClass: "filterTypes" },
                            [
                              _c("f7-label", [_vm._v("Debitor Name")]),
                              _vm._v(" "),
                              _c("f7-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.filterName,
                                  callback: function ($$v) {
                                    _vm.filterName = $$v
                                  },
                                  expression: "filterName",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "f7-list-item",
                        {
                          staticClass: "filterTypes",
                          attrs: { id: "button-clean" },
                        },
                        [
                          _c(
                            "f7-button",
                            {
                              attrs: { fill: "" },
                              on: { click: _vm.cleanFilter },
                            },
                            [_vm._v("Clean Filter")]
                          ),
                          _vm._v(" "),
                          _c(
                            "f7-button",
                            {
                              attrs: { fill: "" },
                              on: { click: _vm.updatePaymentsList },
                            },
                            [_vm._v("Go")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }